import {FormType} from '../../../../../blocks/FormBlock'
import {copy} from '../../../../../../util/fieldscopy'

const schoolCity: FormType = {
	id: 13,
	parent_id: 0,
	channel: 'select',
	name: 'schoolCity',
	label: copy?.school_city.label || 'Gemeente waar de school gelegen is',
	required: true,
	enableFilter: true,
	options: [
		{
			amount: null,
			path: '',
			title: copy?.school_city.option || 'Maak uw selectie'
		}
	]
}

export default schoolCity
